var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('queue-calls-viewer',{attrs:{"customer-calls":_vm.customerCalls,"accounts":_vm.accounts}})}
var staticRenderFns = []

export { render, staticRenderFns }